import { Spinner } from '@99designs/common/components/Spinner';
import Icon from 'launch/components/Icon';
import * as React from 'react';

// Display a spinner when active = true, then a tick before fading out
const ActionStatus: React.SFC<{ active: boolean }> = ({ active }) => (
    <div className={'action-status action-status--' + (active ? 'active' : 'inactive')}>
        {active ? <Spinner /> : <Icon icon="tick-3" />}
    </div>
);

export default ActionStatus;
